"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTechnicianApiClient = createTechnicianApiClient;
const infra_1 = require("../infra");
const axios_client_1 = require("@invivodf/axios-client");
const users_client_1 = require("../users/users.client");
const errors_1 = require("@invivodf/errors");
function createTechnicianApiClient(apiHost, options) {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    const userApiClient = (0, users_client_1.createUserApiClient)(apiHost, options);
    async function fetchTechnicianByPartnerIdAndTechnicianId(partnerId, technicianId) {
        try {
            const response = await client.get(`/v1/partners/${partnerId}/technicians/${technicianId}`);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function fetchTechnicianStores(request) {
        try {
            const response = await client.get(`/v1/partners/${request.partnerId}/technicians/${request.technicianId}/stores`);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    /**
     * @deprecated Use checkUserPermissions directly with the user ID instead
     */
    async function checkTechPermissions(technicianId, permissions, partnerId) {
        try {
            const technician = await fetchTechnicianByPartnerIdAndTechnicianId(partnerId, technicianId);
            if (!technician.userId) {
                throw new errors_1.DomainError(`Could not find userID for sales with id ${technicianId} and partner with id ${partnerId}`, 'errors.technician-user-id.not-found');
            }
            return await userApiClient.checkUserPermissions(technician.userId, permissions);
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    return {
        fetchTechnicianStores,
        fetchTechnicianByPartnerIdAndTechnicianId,
        checkTechPermissions
    };
}
